export default __webpack_public_path__ + "static/media/normal.461bd737.svg";